import axios from 'axios';

  export const SubmitConsent = () => {
    return axios.post(process.env.REACT_APP_SAHMATI_BACKEND_API+"/api/sahamati/submit-consent-request/",{}, {
      headers:{
        "Content-Type": "application/json",
        "Authorization":`Token ${localStorage.getItem('access_token')}`
      }
    });
  };


  export const LoginOtpVerify = (data) => {
    return axios.post(process.env.REACT_APP_SAHMATI_BACKEND_API+"/api/sahamati/login-otp-verify/",data, {
      headers:{
        "Content-Type": "application/json",
        "Authorization":`Token ${localStorage.getItem('access_token')}`
      }
    });
  };

  export const getFpiList= () => {
    return axios.get(process.env.REACT_APP_SAHMATI_BACKEND_API+"/api/sahamati/fip-list/", {
      headers:{
        "Content-Type": "application/json",
        "Authorization":`Token ${localStorage.getItem('access_token')}`
      }
    });
  };
  export const getFpiListSixBanks= () => {
    return axios.get(process.env.REACT_APP_SAHMATI_BACKEND_API+"/api/sahamati/fip-list/?page=1", {
      headers:{
        "Content-Type": "application/json",
        "Authorization":`Token ${localStorage.getItem('access_token')}`
      }
    });
  };
  export const getBankSearchApi= (data) => {
    return axios.get(process.env.REACT_APP_SAHMATI_BACKEND_API+`/api/sahamati/fip-list/?search=${data}`, {
      headers:{
        "Content-Type": "application/json",
        "Authorization":`Token ${localStorage.getItem('access_token')}`
      }
    });
  };

  export const AccountConfirmLkingApi=(data)=>{
    return axios.post(process.env.REACT_APP_SAHMATI_BACKEND_API+"/api/sahamati/user-account-confirm-linking/",data,{
      headers:{
        "Content-Type":'application/json',
        "Authorization":`Token ${localStorage.getItem('access_token')}`
      }
    })
  }

  export const AccountDiscoveryApi=(data)=>{
    return axios.post(process.env.REACT_APP_SAHMATI_BACKEND_API+"/api/sahamati/user-account-discovery/",data,{
      headers:{
        "Content-Type":'application/json',
        "Authorization":`Token ${localStorage.getItem('access_token')}`
      }
    })
  }

  export const UserLinkedAccountApi=(data)=>{
    return axios.post(process.env.REACT_APP_SAHMATI_BACKEND_API+"/api/sahamati/user-linked-accounts/",data,{
      headers:{
        "Content-Type":'application/json',
        "Authorization":`Token ${localStorage.getItem('access_token')}`
      }
    })
  }

  // export const ConsentApprove=(consentHandle,custID)=>{
  //   return axios.get(process.env.REACT_APP_SAHMATI_BACKEND_API+`/api/sahamati/check-consent-status/${consentHandle}/${custID}/`,{
  //     headers:{
  //       "Content-Type":'application/json',
  //       "Authorization":`Token ${localStorage.getItem('access_token')}`
  //     }
  //   })
  // }


  export const ConsentApprove=(consentHandle,custID)=>{
    return axios.get(process.env.REACT_APP_SAHMATI_BACKEND_API+`/api/sahamati/fetch-data/${consentHandle}/${custID}/`,{
      headers:{
        "Content-Type":'application/json',
        "Authorization":`Token ${localStorage.getItem('access_token')}`
      }
    })
  }